<template>
  <div class="container">
    <h3 class="title">文本对比工具</h3>
    <div>
      <div id="mergely-box"><div id="diff"></div></div>
    </div>
    <div class="cont-box">
      <div class="lcont">
        <a href="javascript:;" class="file">从文件中导入
          <input type="file" @change="fileChange($event, 1)">
        </a>
        <div class="btns" @click="downloadLeft">下载</div>
      </div>
      <div class="rcont">
        <a href="javascript:;" class="file">从文件中导入
          <input type="file" @change="fileChange($event, 2)">
        </a>
        <div class="btns" @click="downloadRight">下载</div>
      </div>
    </div>
    <div id="ad_line" style="text-align: center;margin-bottom: 5px;"></div>
    <div class="cont-des">
      <h4>工具介绍</h4>
      <p>本工具可以方便大家快速对比两个文本/代码中的不同之处。</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    mounted() {
      var l_files;
      var r_files;

      $('#diff').mergely({
        cmsettings: {
          readOnly: false
        },
        editor_height: '500px',
        editor_width: ((window.innerWidth - 96) / 2) + 'px',
        sidebar: false,
        lhs: function(setValue) {
          setValue('v1.0 2018-06-10 文本比对功能上线\n如果觉得不错，记得分享给你的朋友');
        },
        rhs: function(setValue) {
          setValue('v1.0 2018-06-10 文本比对功能上线');
        }
      });
      function leftFileSelect(files) {
        l_files = files;
        setLeft(l_files);
      }

      function rightFileSelect(files) {
        r_files = files;
        setRight(r_files);
      }

      function setRight(files) {
        f = files[0];
        var reader = new FileReader();
        reader.onload = (function(file) {
          return function(e) {
            $('#diff').mergely("rhs", this.result);
          };
        })(f);
        reader.readAsText(f, $('#rcode').val());
      }

      function setLeft(files) {
        let f = files[0];
        var f_name = f.name;
        var f_type = f_name.substring(f_name.lastIndexOf("."));
        switch (f_type) {
          case ".js":
            setRender("javascript/javascript.js");
            break;
          case ".css":
            setRender("css/css.js");
            break;
          case ".go":
            setRender("go/go.js");
            break;
          case ".groovy":
            setRender("groovy/groovy.js");
            break;
          case ".c", ".cpp":
            setRender("clike/clike.js");
            break;
          case ".php":
            setRender("php/php.js");
            break;
          case ".xml":
            setRender("xml/xml.js");
            break;
          case ".html":
            setRender("htmlembedded/htmlembedded.js");
            break;
          case ".less":
            setRender("less/less.js");
            break;
          case ".lua":
            setRender("lua/lua.js");
            break;
          case ".md":
            setRender("markdown/markdown.js");
            break;
          case ".vm":
            setRender("velocity/velocity.js");
            break;
          case ".py":
            setRender("python/python.js");
            break;
          case ".properties":
            setRender("properties/properties.js");
            break;
          case ".rb":
            setRender("ruby/ruby.js");
            break;
          case ".sh":
            setRender("shell/shell.js");
            break;
          case ".sql":
            setRender("plsql/plsql.js");
            break;
          case ".erl":
            setRender("erlang/erlang.js");
            break;
          case ".coffee":
            setRender("coffeescript/coffeescript.js");
            break;
          case ".pl":
            setRender("perl/perl.js");
            break;
            defualt: setRender("clike/clike.js");
        }
        var reader = new FileReader();
        reader.onload = (function(file) {
          return function(e) {
            $('#diff').mergely("lhs", this.result);
          };
        })(f);
        reader.readAsText(f, $('#lcode').val());
      }
      function setRender(type) {
        var base_src = "/js/CodeMirror-2.25/mode/";
        $("#render_js").attr("src", base_src + type);
      }
      window.addEventListener('resize', this._onResize = () => {
        $('#diff').mergely({
          editor_height: '500px',
          editor_width: ((window.innerWidth - 96) / 2) + 'px'
        })
        $('#diff').mergely('resize');
      })
    },
    destroyed() {
      window.removeEventListener('resize', this._onResize)
    },
    methods: {
      fileChange(e, left) {
        function setRender(type) {
          var base_src = "/js/CodeMirror-2.25/mode/";
          $("#render_js").attr("src", base_src + type);
        }
        let _this = this
        let file = e.target.files[0]
        if (left === 1) {
          var f_name = file.name;
          var f_type = f_name.substring(f_name.lastIndexOf("."))
          switch (f_type) {
            case ".js":
              setRender("javascript/javascript.js");
              break;
            case ".css":
              setRender("css/css.js");
              break;
            case ".go":
              setRender("go/go.js");
              break;
            case ".groovy":
              setRender("groovy/groovy.js");
              break;
            case ".c", ".cpp":
              setRender("clike/clike.js");
              break;
            case ".php":
              setRender("php/php.js");
              break;
            case ".xml":
              setRender("xml/xml.js");
              break;
            case ".html":
              setRender("htmlembedded/htmlembedded.js");
              break;
            case ".less":
              setRender("less/less.js");
              break;
            case ".lua":
              setRender("lua/lua.js");
              break;
            case ".md":
              setRender("markdown/markdown.js");
              break;
            case ".vm":
              setRender("velocity/velocity.js");
              break;
            case ".py":
              setRender("python/python.js");
              break;
            case ".properties":
              setRender("properties/properties.js");
              break;
            case ".rb":
              setRender("ruby/ruby.js");
              break;
            case ".sh":
              setRender("shell/shell.js");
              break;
            case ".sql":
              setRender("plsql/plsql.js");
              break;
            case ".erl":
              setRender("erlang/erlang.js");
              break;
            case ".coffee":
              setRender("coffeescript/coffeescript.js");
              break;
            case ".pl":
              setRender("perl/perl.js");
              break;
              defualt: setRender("clike/clike.js");
          }
        }

        _this.result = {}

        let reader = new FileReader()
        reader.onload = e => {
          let content = e.target.result
          if (left === 1) {
            $('#diff').mergely("lhs", content);
          } else {
            $('#diff').mergely("rhs", content);
          }
        }
        let encode = left === 1 ? $('#lcode').val() : $('#rcode').val()
        reader.readAsText(file, encode)
      },
      downloadLeft() {
        var content = $('#diff').mergely('get', 'lhs')
        var blob = new Blob([content], {
          type: "text/plain;charset=utf-8"
        })
        saveAs(blob,  new Date().getTime() + '.txt')
      },
      downloadRight() {
        var content = $('#diff').mergely('get', 'rhs')
        var blob = new Blob([content], {
          type: "text/plain;charset=utf-8"
        })
        saveAs(blob, new Date().getTime() + '.txt')
      }
    }
  }
</script>

<style>
  .container {
    width: 1340px;
    margin: auto;
    margin-bottom: 20px;
  }
  .container .title{
    margin: 10px auto;
    font-size: 24px;
    color: #333;
  }
  #mergely-box {
    display: block;
    width: 1340px;
    margin-bottom: 16px;
    overflow: hidden;
  }
  #mergely-box .mergely-column{
    width: 650px !important;
    height: 700px !important;
  }
  .cont-box{
    width: 100%;
    clear: both;
    margin-bottom: 20px;
  }
  .cont-box .lcont{
    width: 50%;
    float: left;
    margin-right: 10px;
  }
  .cont-box .lcont,.cont-box .rcont{

    color: #666;
  }
  .cont-box .file{
   float: left;
   margin-right: 15px;
  }
  .cont-des{
    margin: 10px auto;
  }
  .cont-des h4,.cont-des p{
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue